import React from 'react';
import styled from "styled-components";

const StyledInput = styled.input`
  color: rgba(255, 255, 255, 0.75);
  margin: 5px;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.05);
  outline: 0;
`;

function Input({value,type, ...rest}){

  return (
    <StyledInput value={value!== null && value !==undefined ? value : ''} type={type} {...rest}/>
  )
  
}

export default Input;
